export default __webpack_public_path__ + "static/media/camera.a73e4372.png";